import { Component, Input } from '@angular/core'
import { AngularFireStorage } from 'angularfire2/storage'


@Component({
  selector: 'app-gallery-component',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent {

  public setActiveClass: boolean
  private _imageurl: string
  private _videourl: string

  constructor(private storage: AngularFireStorage) {}

  // Override the passed attribute to set general location of gallery images.
  @Input()
  set image(image: string) {
    this.storage
    .ref('site_assets/images/' + image.trim())
    .getDownloadURL()
    .subscribe(
      res => this._imageurl = res
    )
  }
  get image(): string { return this._imageurl }

  @Input()
  set video(video: string) {
    this.storage
    .ref('site_assets/' + video.trim())
    .getDownloadURL()
    .subscribe(res => {
      this._videourl = res
      this.setActiveClass = true
    })
  }
  get video(): string { return this._videourl }

  @Input() setVisibleBack: boolean
  @Input() flip: boolean
  @Input() initflip: number

  assetLoaded() {
    // Flip image visible on load complete.
    this.setActiveClass = true
  }
}



// WEBPACK FOOTER //
// ./src/app/ipsc/gallery.component.ts